import Vue from "vue";
//npm i -S vue-the-mask
import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);
